import { createElementBlock, openBlock } from "vue";
const _hoisted_1 = ["poster", "src", "autoplay", "loop", "controls"];
const _sfc_main = {
  __name: "CustomVideo",
  props: {
    video: {
      type: Object,
      default: null
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("video", {
        class: "gjs-portal-custom-video",
        preload: "metadata",
        poster: __props.video ? _ctx.$img.getPublicVideoThumbnailUrl(__props.video.path) : null,
        src: __props.video ? _ctx.$img.getPublicVideolUrl(__props.video.path, __props.video.name) : null,
        autoplay: __props.autoplay,
        loop: __props.loop,
        controls: __props.controls
      }, null, 8, _hoisted_1);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VzdG9tVmlkZW8udnVlLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9QYWdlTWFrZXIvQ3VzdG9tVmlkZW8udnVlIl0sInNvdXJjZXNDb250ZW50IjpbIjx0ZW1wbGF0ZT5cblx0PHZpZGVvXG5cdFx0Y2xhc3M9XCJnanMtcG9ydGFsLWN1c3RvbS12aWRlb1wiXG5cdFx0cHJlbG9hZD1cIm1ldGFkYXRhXCJcblx0XHQ6cG9zdGVyPVwidmlkZW8gPyAkaW1nLmdldFB1YmxpY1ZpZGVvVGh1bWJuYWlsVXJsKHZpZGVvLnBhdGgpIDogbnVsbFwiXG5cdFx0OnNyYz1cInZpZGVvID8gJGltZy5nZXRQdWJsaWNWaWRlb2xVcmwodmlkZW8ucGF0aCwgdmlkZW8ubmFtZSkgOiBudWxsXCJcblx0XHQ6YXV0b3BsYXk9XCJhdXRvcGxheVwiXG5cdFx0Omxvb3A9XCJsb29wXCJcblx0XHQ6Y29udHJvbHM9XCJjb250cm9sc1wiIC8+XG48L3RlbXBsYXRlPlxuXG48c2NyaXB0IHNldHVwPlxuY29uc3QgcHJvcHMgPSBkZWZpbmVQcm9wcyh7XG5cdHZpZGVvOiB7XG5cdFx0dHlwZTogT2JqZWN0LFxuXHRcdGRlZmF1bHQ6IG51bGwsXG5cdH0sXG5cdGF1dG9wbGF5OiB7XG5cdFx0dHlwZTogQm9vbGVhbixcblx0XHRkZWZhdWx0OiBmYWxzZSxcblx0fSxcblx0bG9vcDoge1xuXHRcdHR5cGU6IEJvb2xlYW4sXG5cdFx0ZGVmYXVsdDogZmFsc2UsXG5cdH0sXG5cdGNvbnRyb2xzOiB7XG5cdFx0dHlwZTogQm9vbGVhbixcblx0XHRkZWZhdWx0OiB0cnVlLFxuXHR9LFxufSk7XG48L3NjcmlwdD5cbiJdLCJuYW1lcyI6WyJfY3JlYXRlRWxlbWVudEJsb2NrIiwiJGltZyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzBCQUNDQSxtQkFPd0IsU0FBQTtBQUFBLFFBTnZCLE9BQU07QUFBQSxRQUNOLFNBQVE7QUFBQSxRQUNQLFFBQVEsZ0JBQVFDLEtBQUFBLEtBQUssMkJBQTJCLFFBQUssTUFBQyxJQUFJLElBQUE7QUFBQSxRQUMxRCxLQUFLLFFBQUEsUUFBUUEsS0FBQUEsS0FBSyxtQkFBbUIsUUFBQSxNQUFNLE1BQU0sUUFBQSxNQUFNLElBQUksSUFBQTtBQUFBLFFBQzNELFVBQVUsUUFBUTtBQUFBLFFBQ2xCLE1BQU0sUUFBSTtBQUFBLFFBQ1YsVUFBVSxRQUFRO0FBQUE7Ozs7In0=
